export default __webpack_public_path__ + "static/media/banco-ripley.3d51e515.3d51e515.png";